// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_jg-0";
export var discountCodeInput = "_jg-1";